import { useEffect } from 'react';
import ReactDOM from 'react-dom';

const modalRoot = document.getElementById('modal-root');

function Modal({ children, onClose }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modalOverlay')) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div className="modalOverlay" onClick={handleOverlayClick}>
      <div className="modalCard">
        {children}
        <button className="modalClose" onClick={onClose}>×</button>
      </div>
    </div>,
    modalRoot
  );
}

export default Modal;
